import {
  CircleCheckIcon,
  InfoIcon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import { MiniGhibliLoader } from '@/modules/shared/components/ghibli-loader'

const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    theme="light"
    className="toaster group"
    position="top-right"
    richColors={false}
    icons={{
      success: <CircleCheckIcon className="size-5 text-emerald-600" />,
      info: <InfoIcon className="size-5 text-sky-600" />,
      warning: <TriangleAlertIcon className="size-5 text-amber-600" />,
      error: <OctagonXIcon className="size-5 text-rose-600" />,
      loading: <MiniGhibliLoader className="size-5" />,
    }}
    toastOptions={{
      classNames: {
        toast: 
          "group toast group-[.toaster]:bg-white/95 group-[.toaster]:backdrop-blur-md group-[.toaster]:border-white/60 group-[.toaster]:shadow-[0_8px_30px_rgb(0,0,0,0.08)] group-[.toaster]:rounded-2xl group-[.toaster]:p-4 group-[.toaster]:font-['Nunito'] group-[.toaster]:text-slate-700 data-[type=success]:bg-emerald-50/90 data-[type=success]:border-emerald-100 data-[type=error]:bg-rose-50/90 data-[type=error]:border-rose-100 data-[type=warning]:bg-amber-50/90 data-[type=warning]:border-amber-100 data-[type=info]:bg-sky-50/90 data-[type=info]:border-sky-100 transition-all duration-300 ease-out hover:scale-[1.02]",
        title: "group-[.toast]:font-['Patrick_Hand'] group-[.toast]:text-lg group-[.toast]:font-bold group-[.toast]:tracking-wide",
        description: "group-[.toast]:text-slate-600 group-[.toast]:font-medium group-[.toast]:text-sm",
        actionButton:
          "group-[.toast]:bg-slate-800 group-[.toast]:text-white group-[.toast]:font-['Patrick_Hand'] group-[.toast]:rounded-xl",
        cancelButton:
          "group-[.toast]:bg-slate-100 group-[.toast]:text-slate-600 group-[.toast]:font-['Patrick_Hand'] group-[.toast]:rounded-xl",
        closeButton: "group-[.toast]:bg-white/50 group-[.toast]:hover:bg-white/80 group-[.toast]:border-transparent group-[.toast]:text-slate-500",
      },
    }}
    style={
      {
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
        "--border-radius": "var(--radius)",
      } as React.CSSProperties
    }
    {...props}
  />
)

export { Toaster }
